import React, { useState, useEffect, useRef } from 'react';
import { motion } from "framer-motion";
import QAPageSchema from '../Shared/QAPageSchema';
export default function StripFaq(props) {
    var fields = props.fields, children = props.children, isPursuitSite = props.isPursuitSite;
    var TitleTag = (fields.titleTag || 'h1');
    var _a = useState(null), answerIndex = _a[0], setAnswerIndex = _a[1];
    var _b = useState(false), isVisibleLoadMoreButton = _b[0], setIsVisibleLoadMoreButton = _b[1];
    var _c = useState(0), visibleNumberOfItems = _c[0], setVisibleNumberOfItems = _c[1];
    var _d = useState(0), numberOfLoadMoreItems = _d[0], setnumberOfLoadMoreItems = _d[1];
    var wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    useEffect(function () {
        var handleEsc = function (event) {
            if (event.keyCode === 27) {
                setAnswerIndex(null);
            }
        };
        window.addEventListener('keydown', handleEsc);
        return function () {
            window.removeEventListener('keydown', handleEsc);
        };
    }, []);
    useEffect(function () {
        setIsVisibleLoadMoreButton(visibleNumberOfItems < props.children.length ? true : false);
    }, [visibleNumberOfItems]);
    useEffect(function () {
        setIsVisibleLoadMoreButton(fields.initialNumberOfItems < props.children.length ? true : false);
        setVisibleNumberOfItems(fields.initialNumberOfItems);
        setnumberOfLoadMoreItems(parseInt(fields.columns));
    }, []);
    function useOutsideAlerter(ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setAnswerIndex(null);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    var setActiveAnswer = function (i) {
        if (answerIndex == i) {
            setAnswerIndex(null);
        }
        else {
            setAnswerIndex(i);
        }
    };
    return (React.createElement(motion.div, { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" }, className: "strip sky23-faq-container position-relative component mb-4 text-center "
            + ((fields.background) ? (" bg-" + fields.background) : "")
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "")
            + ((isPursuitSite) ? " spa-accordion" : "") },
        React.createElement("div", { className: (isPursuitSite) ? " container" : "" },
            React.createElement("div", { className: "row justify-content-center" },
                React.createElement("div", { className: "col col-lg-10" }, fields.displayTitle &&
                    React.createElement(TitleTag, { className: (fields.titleStyle ? fields.titleStyle : "h1"), dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null)),
            React.createElement("div", { ref: wrapperRef }, children && children.length > 0 && children.map(function (item, index) {
                return (React.createElement(React.Fragment, { key: index }, index < visibleNumberOfItems && React.createElement("div", { className: "col" },
                    React.createElement("div", { className: "faq-item p-4 " + (index == answerIndex ? "expanded" : "compact") },
                        React.createElement("div", { className: "d-flex gap-3" },
                            item.fields.question && React.createElement(React.Fragment, null,
                                QAPageSchema(item.fields),
                                React.createElement("div", { className: "question" }, item.fields.question)) || null,
                            React.createElement("button", { className: "btn rounded-circle btn-expand " + (index == answerIndex ? "minus" : "plus"), title: "Show Answer", onClick: function () { return setActiveAnswer(index); } })),
                        item.fields.answer && React.createElement("div", { className: "answer-container", dangerouslySetInnerHTML: { __html: item.fields.answer } }) || null)) || null));
            })))));
}
